<template>
  <div v-if="this.cards.length > 0" class="container border-top">
        
    <h3 class="font-weight-bold pt-4 pb-2">{{ this.title }}</h3>
    <!-- Carousel for large screens -->
    <div v-if="isLargeScreen && this.cards.length > 0" class="mb-4">
      <div :id="carouselLarge" class="carousel slide" data-interval="false">
        <!-- Indicators -->
        <ol v-if="showCarouselControls" class="carousel-indicators outside">
          <li v-for="(chunk, index) in chunkedCards(chunks)" :key="index" :data-target="'#' + carouselLarge" :data-slide-to="index" :class="{ active: index === 0 }"></li>
        </ol>
                
        <div class="carousel-inner">
          <div
            v-for="(chunk, index) in chunkedCards(chunks)"
            :key="index"
            :class="['carousel-item', { active: index === 0 }]"
            >
          <div class="cards rounded d-flex justify-content-left">
            <div class="card proportional-card list-group-item-action p-3" v-for="(card, cardIndex) in chunk" :key="cardIndex">
              <a :href="ruta+card.slug" class="text-decoration-none text-reset">
                <div class="position-relative rounded overflow-hidden" style="padding-bottom: 100%;">
                  <!-- Badge de Automotora -->
                  <span 
                    v-if="card.typeuser_id == 2 && card.category_id == 100"
                    class="badge bg-danger position-absolute shadow-sm text-white"
                    style="top: 0.1rem; right: 0; font-size: 0.9rem; z-index: 1;"
                  >
                    Automotora
                  </span>

                  <!-- Imagen centrada con proporción -->
                  <div class="position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
                    <img class="img-fluid"
                        style="max-width: 100%; max-height: 100%; object-fit: contain;" 
                        :src="/post_images/ + card.id + '/' + card.imgSrc" alt="Card image cap">
                  </div>
                </div>
                <div class="card-body p-0 pt-2">
                    <div class="d-flex w-100 justify-content-between">
                      <h5 class="mb-1 title">{{ card.title }}</h5>
                    </div>
                    <h4 class="text-price font-weight-bold" data-formatter="NumFormatter">
                      {{ card.maxprice.toLocaleString("es-CL", { style: "currency", currency: "CLP" }) }}
                    </h4>
                    <small class="region" style="display: block; width: 100%;">
                      <i class="far fa-compass pr-1"></i>
                      {{ card.region }}
                    </small>
                    <small style="font-size: 0.7em !important;"
                      class="d-inline px-2 py-1 table-primary rounded">{{ nombre_estado + card.state }}</small>
                    <p class="mb-0"><small style="font-size: 0.7em !important;">{{ formatearFecha(card.created_at)
                        }}</small></p>
                  </div>
              </a>
              </div>
            </div>
          </div>
        </div>
        <a v-if="showCarouselControls" class="carousel-control-prev" :href="'#'+carouselLarge" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a v-if="showCarouselControls" class="carousel-control-next" :href="'#'+carouselLarge" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
      
    </div>

    <!-- Carousel for small screens -->
    <div v-else-if="this.cards.length > 0">
      <div class="container">
        <div class="row">
          <div
            v-for="(card, index) in cards"
            :key="index"
            class="col-6 d-flex justify-content-center px-0"
          >
            <div
              :class="['w-100', 'card', 'proportional-card', 'list-group-item-action', { 'disabled-card': card.stock == 0 }, {'d-none d-sm-block': index >= 6}]"
            >
              <a :href="card.stock != 0 ? ruta + card.slug : '#void'" class="text-decoration-none text-reset">

              <span 
                  v-if="card.typeuser_id == 2 && card.category_id == 100"
                  class="badge bg-danger position-absolute m-1 shadow-sm text-white"
                  style="top: 0.1rem; right: 0; font-size: 0.9rem; z-index: 1;"
                >
                  Automotora
                </span>
                <!-- Imagen con badge -->
                <div class="position-relative rounded overflow-hidden" style="padding-bottom: 100%;">
                  
                  <div class="position-absolute w-100 h-100 d-flex justify-content-center align-items-center px-1">
                    <img class="img-fluid" 
                      style="max-width: 100%; max-height: 100%; object-fit: contain;" 
                      :src="/post_images/ + card.id + '/' + card.imgSrc" alt="Card image cap">
                  </div>
                </div>
              <div class="card-body p-0 pt-2">
                  <h5 class="mb-1 title">{{ card.title }}</h5>
                  <h4 class="text-price font-weight-bold h5">
                    {{ card.maxprice.toLocaleString("es-CL", { style: "currency", currency: "CLP" }) }}
                  </h4>
                  <small class="d-block region pb-1">
                    <i class="far fa-compass pr-1"></i> {{ card.region }}
                  </small>
                  <small class="d-inline px-1 py-1 table-primary rounded">
                    {{ nombre_estado + card.state }}
                  </small>
                  <p class="mb-0">
                    <small style="font-size: 0.66em !important;">
                      {{ formatearFecha(card.created_at) }}
                    </small>
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
        
      <button v-if="showCarouselControls" type="button" class="btn btn-outline-primary w-100 btn-block mb-2 mt-3 mr-2" @click="goToDetail">Ver todo</button>
    </div>
</template>

<script>
export default {
  props: ['id', 'title', 'user_p', 'slug_p', 'idp'],
  data() {
    return {
      isLargeScreen: window.innerWidth >= 768,
      cards: [],
      chunks: 4,
      carouselLarge: 'carouselLarge' + this.id,
      carouselSmall: 'carouselSmall' + this.id,
      ruta: '',
      nombre_estado: '',
    };
  },
  computed: {
    showCarouselControls() {
      return this.cards.length > this.chunks;
    }
  },
  methods: {
    chunkedCards(chunkSize) {
      const result = [];
      for (let i = 0; i < this.cards.length; i += chunkSize) {
        result.push(this.cards.slice(i, i + chunkSize));
      }
      return result;
    },
    handleResize() {
      this.chunks = 1;
      this.isLargeScreen = window.innerWidth >= 768;
      if (window.innerWidth >= 576 && window.innerWidth < 992) {
        this.chunks = 3;
      } 
      else if (window.innerWidth >= 992 && window.innerWidth < 1278) {
        this.chunks = 4;
      }
      else if (window.innerWidth >= 1278){
        this.chunks = 5;
      }
    },
    formatearFecha(fechaOriginal) {
      const fecha = new Date(fechaOriginal);
      const dia = fecha.getDate().toString().padStart(2, '0');
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Los meses en JavaScript van de 0 a 11, por eso se suma 1
      const anio = fecha.getFullYear();

      // Formatear la fecha en el formato deseado
      const fechaFormateada = `Publicado: ${dia}-${mes}-${anio}`;
      return fechaFormateada;
    },
    goToDetail() {
      if (this.user_p == 1){
        localStorage.filtro = this.id == 'opv_100' ? `Usuario_100: ${this.idp}` : `Usuario: ${this.idp}`;
      }else{
        localStorage.filtro = this.id == 'opr_100' ? `Relacionados_100: ${this.slug_p}` : `Relacionados: ${this.slug_p}`;
      }
      if (this.$route.path.includes('/inicio/list/detalle')){
        window.location.href = this.$router.resolve({ name: 'lista' }).href;
        this.ruta = '/inicio/list/detalle/';       
      }else{
        window.location.href = this.$router.resolve({ name: 'list' }).href;
        this.ruta = '/list/detail/';
      }
      
    },
    getPosts() {
      //console.log(this.user_p);
      if (this.user_p == 1){
        fetch("/api/posts_user/" + this.slug_p)
          .then((response) => response.json())
          .then((json) => {
            this.cards = json.data;
          });
      }else if (this.user_p == 0){
        fetch("/api/posts_related/" + this.slug_p)
          .then((response) => response.json())
          .then((json) => {
            this.cards = json.data;
          });
      } 
    }
  },
  mounted() {
    this.getPosts();
    this.handleResize(); // Llamar a handleResize para configurar correctamente los chunks al montar el componente
    window.addEventListener('resize', this.handleResize);
    this.nombre_estado = this.title.includes('vehículos') ? 'Vehículo ' : 'Producto ';
  },
  /*beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },*/  
};
</script>

<style scoped>
.cards-wrapper {
  display: flex;
  justify-content: center;
}

.card {
  flex: 1;
  max-width: 250px;
  /* Adjust the max-width to control the card size */
}

.carousel-inner {
  display: flex;
}

.carousel-control-prev,
.carousel-control-next {
  background-color: #3d3c3c;
  width: 5vh;
  height: 5vh;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%);
}

.fecha {
  font-size: 0.8em;
}

.cursor-pointer {
  cursor: pointer;
}

.carousel-image {
  width: 100%;
  /* Ajusta el ancho de la imagen al contenedor */
  height: 200px;
  /* Ajusta la altura de la imagen según sea necesario */
  object-fit: cover;
  /* Recorta y centra la imagen para que cubra el área especificada */
}

.carousel-indicators.outside {
  position: static;
  text-align: center;
}

.carousel-indicators.outside li {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 1px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #052453;
  border: none;
  border-radius: 50%;
}

.carousel-indicators.outside .active {
  background-color: #0b4fb1
}

.proportional-card {
  width: 20vw;
  height: auto;
  border-radius: 10px;
}

.title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  min-height: 2.5em;  
  /* Necesario para que el texto se ajuste en múltiples líneas */
}

.disabled-link {
  pointer-events: none;
  cursor: default;
  color: #6c757d; /* Cambia el color si lo deseas */
}

.disabled-card {
  background-color: #ebedef !important;
}

.disabled-image{
  opacity: 0.5;
}

.v-lazy-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.container {
  padding: 10px !important;
}
.region {
  min-height: 2em; 
  /* Necesario para que el texto se ajuste en múltiples líneas */
}
</style>
